import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityConfig } from '../_appCommon/base/EntityConfig';
import { EntityDataServiceBase } from '../_appCommon/base/EntityDataServiceBase';
import { IPage, PageResult } from '../_appCommon/base/Pagination';
import { UrlQueryDef } from '../_appCommon/base/UrlQueryDef';

@Injectable()
export class PatientDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient)
  {
    super(http, 'patient');
  }

  protected loadEntityConfig(): void
  {
    this.entityConfig = new EntityConfig();

    this.entityConfig.entityDisplayName = 'patient';
    this.entityConfig.apiUrl = 'api/Patient';
  }

  public getPatientFiltered(queryDef: UrlQueryDef, pageSize: number = 10, pageNumber: number = 0): Observable<IPage<any>>
  {
    queryDef = this.getPaginationQueryDef(queryDef, pageSize, pageNumber);

    let request = this.http.get<PageResult<any>>(this.createUrl('filter'), queryDef.getRequestConfig());

    let observable = this.getPageValues(request, queryDef);

    return observable;
  }
}

